var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var ContentContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    & > .ReactCollapse--collapse {\n        transition: height\n            ", ";\n    }\n"], ["\n    & > .ReactCollapse--collapse {\n        transition: height\n            ", ";\n    }\n"])), function (props) {
    return props.transitionTime !== null && props.transitionTime !== undefined
        ? props.transitionTime + "ms"
        : '500ms';
});
export var HeaderSection = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""]))); //To be updated later as required
export var FooterSection = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""]))); //To be updated later as required
var templateObject_1, templateObject_2, templateObject_3;
